import { render, staticRenderFns } from "./SoftwareComponentTypeView.vue?vue&type=template&id=5367870e&"
import script from "./SoftwareComponentTypeView.vue?vue&type=script&lang=js&"
export * from "./SoftwareComponentTypeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports